module.exports = __webpack_public_path__ + "img/but.59d89a0a.png";